import { render, staticRenderFns } from "./CityEvents.vue?vue&type=template&id=1a45d8e7&scoped=true&"
import script from "./CityEvents.vue?vue&type=script&lang=js&"
export * from "./CityEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a45d8e7",
  null
  
)

export default component.exports